import React from 'react';

import {
  Header as TopListHeaderWrapper,
  HeaderContainer,
  ContentWrapper,
  MobileWrapper,
  Title,
} from './HelpHeader.style';
import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import Layout from 'components/styled/Layout/Layout';
import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';

const HelpHeader: React.FC = () => {
  return (
    <InViewObserver
      render={({ inview }: any): JSX.Element => (
        <Header inView={inview} withVerticalBackground>
          <TopBar
            inView={inview}
            entityTitle="Opus Help"
            simpleTextTopBar
            inNewDesign
            isSticky
          />
          <Layout.MaxWidth>
            <HeaderContainer>
              <TopListHeaderWrapper>
                <ContentWrapper data-pw="header-top-bar">
                  <MobileWrapper>
                    <Title>Opus Help</Title>
                  </MobileWrapper>
                </ContentWrapper>
              </TopListHeaderWrapper>
            </HeaderContainer>
          </Layout.MaxWidth>
        </Header>
      )}
    />
  );
};

export default HelpHeader;
